import { memo } from 'react';
import styled from '@emotion/styled';
import { PROMOTE_I18N_NS } from 'hooks/business/usePromoteDays';
import bgPic from './bg.png';
import { T } from '@tolgee/react';
import { useMarketPromotion } from '../../hooks/useMarketPromotion';

const Bar = styled.div`
  background: #d0dfff url(${bgPic});
  height: 88px;
  padding-left: 120px;
  background-size: contain;
  background-repeat: no-repeat;
  font-size: 28px;
  color: #1754bb;
  border-radius: 4px;
  font-family: microsoft YaHei;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  > strong {
    position: relative;
    top: 3px;
    color: #f26b72;
    margin: 0 0.2em;
    font-size: 40px;
  }
`;
const Time = styled.p`
  font-size: 12px;
  color: #264272;
`;

const PromoteBanner = ({ className }: { className?: string }) => {
  const { visible, annualPackage } = useMarketPromotion();
  if (!visible) {
    return null;
  }
  return (
    <Bar className={className}>
      <T
        ns={PROMOTE_I18N_NS}
        keyName="promote.banner.text"
        params={{ n: annualPackage?.giftMonths, strong: <strong /> }}
        defaultValue=""
      />
      <Time>
        <T ns={PROMOTE_I18N_NS} keyName="promote.banner.time.range" />
      </Time>
    </Bar>
  );
};
export default memo(PromoteBanner);
